import React, { useState } from 'react';
import { Poppins } from 'src/common';
import Button from 'src/components/form/Button';
import { useAuth } from 'src/state/auth';
import { ContentWrap } from 'src/components/FiltersSlider/styled';
import { GenericList } from 'src/components/FiltersSlider/comps/GenericList';
import { FilterOptionWithEmail } from 'src/components/FiltersSlider/types';

interface ContentUsersProps {
  onClose: () => void;
  filters: FilterOptionWithEmail[];
  setFilters: (filters: FilterOptionWithEmail[]) => void;
  title: string;
}

export const ContentUsers: React.FC<ContentUsersProps> = ({ onClose, filters, setFilters, title }) => {
  const [localFilters, setLocalFilters] = useState(filters);
  const [search, setSearch] = useState('');
  const { profile } = useAuth();

  const handleOnSelect = (label: string) => {
    setLocalFilters((prev) => prev.map((el) => (el.label === label ? { ...el, enabled: !el.enabled } : el)));
  };

  const handleOnSelectAll = (isAdd: boolean) => {
    setLocalFilters((prev) => {
      const shouldModify = (el: FilterOptionWithEmail) =>
        !search || el.label.toLowerCase().includes(search.toLowerCase());
      return prev.map((el) => (shouldModify(el) ? { ...el, enabled: isAdd } : el));
    });
  };

  const onApply = () => {
    setFilters(localFilters);
    onClose();
  };

  const isAllSelectedFromSearch = localFilters
    .filter((el) => el.label.toLowerCase().includes(search.toLowerCase()))
    .every((el) => el.enabled);

  return (
    <ContentWrap className="styled-scroll styled-scroll--rounded" style={{ width: 420 }}>
      <div className="chead gutter">
        <Poppins px={18} weight={500}>
          {title}
        </Poppins>
        <Poppins
          className="chead__select-all"
          px={14}
          weight={500}
          onClick={() => handleOnSelectAll(!isAllSelectedFromSearch)}
        >
          {isAllSelectedFromSearch ? 'Deselect All' : 'Select All'}
        </Poppins>
      </div>
      <div className="ccontent">
        <GenericList<FilterOptionWithEmail>
          filters={localFilters}
          handleOnSelect={handleOnSelect}
          searchString={search}
          setSearchString={setSearch}
          emptyTextWithSearch="It looks like there aren't any users yet."
          checkIsYou={(opt) => new RegExp(profile?.user?.email as string, 'i').test(opt.email ?? '')}
        />
      </div>
      <div className="btns gutter">
        <Button secondary onClick={onClose}>
          CANCEL
        </Button>
        <Button primary onClick={onApply}>
          APPLY
        </Button>
      </div>
    </ContentWrap>
  );
};
